<!-- eslint-disable @angular-eslint/template/no-call-expression -->
<div class="d-flex justify-content-between align-items-center">
  <h5>{{ 'account.benefit.title' | transloco }}</h5>
  @if (rootData.getSelectedCustomerItem()) {
    <div class="d-flex align-items-end">
      <div class="circle mr-2">
        <a
          [href]="environment.apihost + '/api/moneytransaction/umsaetze.csv?customerId=' + rootData.getSelectedCustomerItem().custId"
          target="_blank"
          rel="noopener noreferrer"
        >
          <svg class="icon icon-16 text-color-grey">
            <use xlink:href="/assets/img/svgs/svgset.svg#download-redesign-23" />
          </svg>
        </a>
      </div>
      <web-design-system-list-toggle (click)="showMe = !showMe" [isCollapsed]="!showMe" />
    </div>
  }
</div>
<web-design-system-divider />
@if (showMe) {
  <div class="col-12 p-0">
    @if (customerStateFacade.customerAccountData$ | async; as customerAccount) {
      <div class="row font-regular mb-2">
        <div class="col-auto font-bold">
          {{ 'account.benefit.balance' | transloco }} <span class="font-regular">{{ 'account.benefit.past-benefit' | transloco }}</span
          >:
        </div>
        <div class="col-auto text-align-right font-bold">
          {{ customerAccount.intradayAmount | currency: 'EUR' : 'symbol' }}
        </div>
      </div>
    }
    <table class="table-depot" @onlyEnter aria-describedby="money-transaction-overview">
      <tbody>
        <tr>
          <th>
            <span [ngClass]="getSorterClasses('after', 'bookingDate')" (click)="sortBy('bookingDate')">
              {{ 'account.benefit.date' | transloco }}
            </span>
            <br />
            {{ 'account.benefit.value-date' | transloco }}
          </th>
          <th>{{ 'account.benefit.amount' | transloco }}</th>
          <th>{{ 'account.benefit.status' | transloco }}</th>
          <th>{{ 'account.benefit.purpose' | transloco }}</th>
          <th></th>
        </tr>
        @for (mt of rootData.moneyTransactions | slice: 0 : pageSize; track mt.id) {
          <tr>
            <td>
              <div class="d-flex">
                <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow mr-1">{{ 'account.benefit.date' | transloco }}</div>
                <div>
                  {{ (mt.bookingDate ? mt.bookingDate : mt.createdDateTime) | date: 'shortDate' }}
                </div>
              </div>
              <div class="d-flex">
                <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow mr-1">
                  {{ 'account.benefit.value-date' | transloco }}
                </div>
                <div>
                  {{ mt.valutaDate | date: 'shortDate' }}
                </div>
              </div>
            </td>
            <td>
              <div class="d-flex justify-content-end">
                <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow mr-1">
                  {{ 'account.benefit.amount' | transloco }}
                </div>
                <div
                  class="zero-text"
                  [class.p-base-bold]="showHighlighted(mt)"
                  [class.course-green]="mt.amount > 0"
                  [class.course-red]="mt.amount < 0"
                >
                  {{ mt.amount | currency: 'EUR' : 'symbol' }}
                </div>
              </div>
            </td>
            <td>
              <div class="d-flex justify-content-end text-color-primary">
                <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow mr-1">
                  {{ 'account.benefit.status' | transloco }}
                </div>
                <div class="text align-items-end" [class.font-bold]="showHighlighted(mt)">
                  {{ mt | moneyTransactionStatus }}
                </div>
              </div>
            </td>
            <td>
              <div class="d-flex justify-content-end flex-column">
                <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow mr-1">
                  {{ 'account.benefit.purpose' | transloco }}
                </div>
                <div
                  class="text align-items-end"
                  [ngClass]="{
                    'text-strike-through': !!mt.matchedImportStorno,
                    'font-bold': showHighlighted(mt),
                  }"
                >
                  {{ mt.purpose }}
                </div>
              </div>
            </td>
            <td>
              @if (!(mt.status === 'Matched' || mt.status === 'Deleted')) {
                <div class="btn-icon disabled">
                  <svg class="icon icon-inactive icon-24">
                    <use xlink:href="/assets/img/svgs/svgset.svg#preview-redesign" />
                  </svg>
                </div>
              }
              @if (mt.status === 'Matched' || mt.status === 'Deleted') {
                <a
                  [href]="getURI(mt)"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Abrechnung aufrufen"
                  (click)="deleteCachedDocuments()"
                >
                  <div class="btn-icon cursor-pointer">
                    <svg class="icon icon-24">
                      <use xlink:href="/assets/img/svgs/svgset.svg#preview-redesign" />
                    </svg>
                  </div>
                </a>
              }
            </td>
          </tr>
        }
      </tbody>
    </table>
    @if (rootData.hasMoreMoneyTransactions) {
      <div class="row d-flex justify-content-end">
        <div class="col-12 col-lg-2 text-right">
          <a (click)="more()" class="link-secondary cursor-pointer">
            {{ 'tradable-products.more' | transloco }} <span class="sorter-after-flat sorter-after-flat--down"></span
          ></a>
        </div>
      </div>
    }
  </div>
}
